module.exports = __webpack_public_path__ + "static/img/evidence6.5c14858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/evidence6.png
// module id = MfYI
// module chunks = 1 3